import type { Components } from "@mui/material/styles";

import type { Theme } from "../types";

export const MuiBadge = {
	styleOverrides: {
		root: {
			variants: [
				{
					props: { variant: "light", color: "primary" },
					style: {
						"& .MuiBadge-badge": {
							backgroundColor: "var(--mui-palette-primary-light)",
							color: "var(--mui-palette-primary-900)",
						},
					},
				},
				{
					props: { variant: "light", color: "secondary" },
					style: {
						"& .MuiBadge-badge": {
							backgroundColor: "var(--mui-palette-secondary-light)",
							color: "var(--mui-palette-secondary-900)",
						},
					},
				},
				{
					props: { variant: "light", color: "success" },
					style: {
						"& .MuiBadge-badge": {
							backgroundColor: "var(--mui-palette-success-light)",
							color: "var(--mui-palette-success-900)",
						},
					},
				},
				{
					props: { variant: "light", color: "info" },
					style: {
						"& .MuiBadge-badge": {
							backgroundColor: "var(--mui-palette-info-light)",
							color: "var(--mui-palette-info-900)",
						},
					},
				},
				{
					props: { variant: "light", color: "warning" },
					style: {
						"& .MuiBadge-badge": {
							backgroundColor: "var(--mui-palette-warning-light)",
							color: "var(--mui-palette-warning-900)",
						},
					},
				},
				{
					props: { variant: "light", color: "error" },
					style: {
						"& .MuiBadge-badge": {
							backgroundColor: "var(--mui-palette-error-light)",
							color: "var(--mui-palette-error-900)",
						},
					},
				},
			],
		},
	},
} satisfies Components<Theme>["MuiBadge"];
